import {
  GET_REPORT_SUBMITTED_TIME,
  GET_REPORT_SUBMITTED_TIME_SUCCESS,
  GET_REPORT_SUBMITTED_TIME_ERROR,
} from "./actionTypes"

export const getReportSubmittedTime = (params, download) => ({
  type: GET_REPORT_SUBMITTED_TIME,
  payload: params,
  exports: download,
})

export const getReportSubmittedTimeSuccess = data => ({
  type: GET_REPORT_SUBMITTED_TIME_SUCCESS,
  payload: data,
})

export const getReportSubmittedTimeError = error => ({
  type: GET_REPORT_SUBMITTED_TIME_ERROR,
  payload: error,
})
